import DOMPurify from 'dompurify'
import { i18n } from 'src/config/i18n.ts'

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  const isExternalLink = (node) => {
    return node.tagName === 'A' && node.hasAttribute('target') && node.getAttribute('target') === '_blank'
  }

  const secureExternalHref = (node) => {
    // if it's an <a href> tag with target="_blank", we need to make sure that rel="noopener" is set
    // read more: https://web.dev/external-anchors-use-rel-noopener/
    node.setAttribute('rel', 'noopener')
  }

  const addExternalLinkScreenReaderHint = (node) => {
    const srOnlyElement = document.createElement('span')
    srOnlyElement.classList.add('sr-only')
    srOnlyElement.textContent = i18n.global.t('accessibility.external_url')
    node.insertAdjacentElement('afterbegin', srOnlyElement)
  }

  const addExternalLinkIcon = (node) => {
    node.classList.add('d-inline-flex', 'align-items-center')

    const iconElement = document.createElement('span')
    iconElement.setAttribute('aria-hidden', 'true')
    iconElement.classList.add('icon-externallink-o', 'ml-1', 'icon-16', 'icon', 'd-inline-flex')
    node.appendChild(iconElement)
  }

  if (!isExternalLink(node)) return
  secureExternalHref(node)
  addExternalLinkScreenReaderHint(node)
  addExternalLinkIcon(node)
})
